<div
  class="mbs-checkbox"
  mbs-input-label
  [class.-lg]="size === MbsSize.lg"
  [class.-pin-mode]="pinMode"
  [class.-sm]="size === MbsSize.sm"
  [boldLabel]="boldLabel"
  [center]="centerCheckbox"
  [disabled]="disabledState"
  [id]="id"
  [info]="info"
  [infoPlacement]="infoPlacement"
  [infoTriggers]="infoTriggers"
  [infoContainer]="infoContainer"
  [label]="label"
  [labelClasses]="labelClasses"
  [labelContext]="labelContext"
  [labelContentClasses]="labelContentClasses"
  [labelPosition]="labelPosition"
  [labelSize]="labelSize"
  [required]="hasRequiredValidator && showRequiredMark"
  [type]="'checkbox'">
  <ng-content
    ngProjectAs="[prependLabel]"
    select="[prependLabel]" />

  <input
    class="mbs-checkbox_input"
    type="checkbox"
    [checked]="checked"
    [disabled]="disabledState"
    [id]="id"
    [indeterminate]="indeterminate"
    [tabindex]="tabindex"
    (change)="handleChange($event)" />

  <ng-content />

  <ng-content
    ngProjectAs="[appendLabel]"
    select="[appendLabel]" />
</div>

@if (subtitle && !subtitleHide) {
  <div
    class="mbs-checkbox_subtitle"
    [class.-disabled]="disabledState"
    [class.-inside]="!subtitleOutside"
    [class.-lg]="!subtitleOutside && size === MbsSize.lg"
    [class.-sm]="!subtitleOutside && size === MbsSize.sm"
    [ngClass]="subtitleClasses">
    {{ subtitle }}
  </div>
}

@if (checkboxDescriptionRef && !checkboxDescriptionRef.hide) {
  <div
    class="mbs-checkbox_description"
    [class.-inside]="!descriptionOutside"
    [class.-lg]="!descriptionOutside && size === MbsSize.lg"
    [class.-sm]="!descriptionOutside && size === MbsSize.sm"
    [ngClass]="descriptionClasses">
    <ng-template [ngTemplateOutlet]="checkboxDescriptionRef?.template" />
  </div>
}
